import { render } from "./general_query.vue?vue&type=template&id=a3bbc95c&scoped=true"
import script from "./general_query.vue?vue&type=script&lang=js"
export * from "./general_query.vue?vue&type=script&lang=js"

import "./general_query.vue?vue&type=style&index=0&id=a3bbc95c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3bbc95c"]])

export default __exports__